export default "__VITE_ASSET__BA5OyFW6__"